// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import api from '../api';

import { apiURL } from "@/app.config";

export default {
  namespaced: true,
  state: {
    list: [],
    selectedPatient: undefined,
    overallAdherence: 0.0,
    reporturl: '',
    anomalyList: [],
  },
  getters: {
    filteredByReference: (state) => (str) => {
      return state.list.filter(p => str == ''
                               || p.Name.toLowerCase().includes(str.toLowerCase()));
    },
    findPatient: (state) => (id) => {
      let p = state.list.find(function(patient) {
        return patient.ID === id;
      });
      return p;
    },
  },
  mutations: {
    setPatients(state, patients) {
      state.list = patients || [];
    },
    addNewPatient(state, patient) {
      state.list.push(patient);
    },
    splicePatient(state, patient) {
      let idx = state.list.indexOf(patient);
      if (idx > -1) {
        state.list.splice(idx, 1);
      }
    },
    updatePatient(state, patient) {
      let p = state.list.find(function(item) {
        return item.ID === patient.ID;
      });

      let idx = state.list.indexOf(p);
      if (idx > -1) {
        Vue.set(state.list, idx, patient);
        state.selectedPatient = patient;
      } 
    },
    setSelectedPatient(state, id) {
      state.selectedPatient = state.list.find(function(patient) {
        return patient.ID === id;
      });
    },
    setOverallAdherence(state, score) {
      state.overallAdherence = score;
    },
    setReportUrl(state, hash) {
      state.reporturl = `${apiURL}report/${hash}/pharmacist`;
    },
    setAnomalyList(state, list) {
      state.anomalyList = list
    }
  },
  actions: {
    async getAllPatients({commit}) {
      try {
        let data = await api.getPatients();
        commit('setPatients', data.patients);
      } catch (err) {
        alert(err);
      }
    },
    async getOverallAdherence({commit}, patient) {
      let data = await api.getPatientOverallAdherence(patient);
      commit("setOverallAdherence", data)
    },
    async getReportHash({commit}, patient) {
      let hash = await api.getReportHash(patient)
      commit("setReportUrl", hash)
    },
    async newPatient({commit}, patient) {
      let p = await api.storePatient(patient);
      if (p != null)  {
        commit('addNewPatient', p);
        return p;
      }
      return null;
    },
    async storePatient({commit}, patient) {
      let p = await api.storePatient(patient);
      if (p != null) {
        commit('updatePatient', p);
      } 
    },
    async removePatient({commit}, patient) {
      let ok = await api.removePatient(patient);
      if (ok) {
        commit('splicePatient', patient);
      }
      return ok;
    },
    async updateRecipients({dispatch, state}, recipients) {
      let p = Object.assign({}, state.selectedPatient);
      p.Recipients = recipients;
      dispatch('storePatient', p);
    },
    async updateReminders({dispatch, state}, reminders) {
      let p = Object.assign({}, state.selectedPatient);
      p.Reminders = reminders;
      dispatch('storePatient', p);
    },
    async updateAnomalyList({commit}) {
      let l = await api.fetchAnomalyList()
      if (l != null) {
        commit('setAnomalyList', l)
      }
    },
  }
}
